import type { InputHTMLAttributes } from "react";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
    className?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({ className = "", autoFocus, ...rest }, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    useEffect(() => {
        if (autoFocus) {
            inputRef.current?.focus();
        }
    }, [autoFocus]);

    return (
        <input
            ref={inputRef}
            className={`border-dark-border bg-dark-surface-elevated mt-1 block w-full rounded-md py-2 pl-3 text-base text-gray-200 focus:border-teal-500 focus:ring-teal-500 focus:outline-none sm:text-sm ${className}`}
            {...rest}
        />
    );
});

TextInput.displayName = "TextInput";

export default TextInput;
